function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();

    var event = new CustomEvent("quantityUpdated", { detail: { quantity: this.input.value } });
    document.dispatchEvent(event);
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();

      var event = new CustomEvent("selectedVariant", { detail: { variantId: this.currentVariant } });
      document.dispatchEvent(event);
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        
        document.dispatchEvent(new CustomEvent("variant:price:change", { detail: price }));
        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
        
        document.dispatchEvent(new CustomEvent('variant:change', {detail:this.currentVariant}));
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);




// 
$(document).ready(function(){
setTimeout(function () {
  $('.text-with-tab .title-tab .tab a.tab1').trigger('click');
}, 200);

  $(".text-with-tab .title-tab .tab a").click(function(){
    $(".text-with-tab .concern-block.main-tab").slick("refresh");
    $(".text-with-tab .title-tab .tab a").removeClass("active");
    $(this).addClass("active");
    var SelectTab = $( this ).attr('select-tab');
    var ShowTab = '[show-tab="'+ SelectTab +'"]';

    $(".main-tab").hide();
    $(ShowTab).fadeIn('fast');
  });

  setTimeout(function () {
    $('.text-with-tab .category-name-list a:first-child').trigger('click');
  }, 200);

  $(".text-with-tab .category-name-list a").click(function(){
    $(".text-with-tab .category-name-list a").removeClass("active");
    $(this).addClass("active");
    var CategorySelectTab = $( this ).attr('select-id');
    var CategoryShowTab = '[block-id="'+ CategorySelectTab +'"]';

    $(".category-list").hide();
    $(CategoryShowTab).fadeIn('fast');
  });
  
  $('.concern-slider').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: false,
    onComplete:function(){
    $(".concern-slider").slick("refresh");
    },
    // prevArrow:"<button type='button' class='slick-prev pull-left' aria-label='prevArrow'><img src='https://cdn.shopify.com/s/files/1/0608/6308/6774/t/27/assets/left-arrow.svg?v=1695708437' loading='lazy' alt='left-arrow' width='50' height='50'></button>",
    // nextArrow:"<button type='button' class='slick-next pull-right' aria-label='nextArrow'><img src='https://cdn.shopify.com/s/files/1/0608/6308/6774/t/27/assets/right-arrow.svg?v=1695708445' loading='lazy' alt='right-arrow' width='50' height='50'></button>",
    responsive: [
      {
        breakpoint: 1551,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 901,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 551,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  $('.reviews-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.image-text-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1381,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

let trust_icons_drop = document.querySelectorAll('.trust-icon-slider');
  trust_icons_drop?.forEach((trust_icons)=> {
      $(trust_icons).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: trust_icons.dataset.arrowVisible === "true",
        dots: false,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 601,
            settings: {
              slidesToShow: 4,
              arrows: trust_icons.dataset.arrowVisibleMob === "true",
            }
          },
          {
            breakpoint: 340,
            settings: {
              slidesToShow: 4,
              arrows: trust_icons.dataset.arrowVisibleMob === "true",
            }
          },
        ]
      });
  });
  
  
});

// home faq
$(document).ready(function() {
  $(".accordion-faq").find(".accordion-toggle").click(function() {
    $(this).next().slideToggle("slow");
      $(this).toggleClass("active");
      $(".accordion-content").not($(this).next()).slideUp("slow");
      $(".accordion-toggle").not($(this)).removeClass("active");
  });
});

// accodian product
$(document).ready(function() {
  $(".accordion-pro").find(".accordion-toggle").click(function() {

    var parent = $(this).parent();
    
    $(this).next().slideToggle("slow");
    $(this).toggleClass("active");
  
    $(".accordion-product .accordion-pro .accordion-section").removeClass("active");
    parent.toggleClass("active");
  
    $(".accordion-content").not($(this).next()).slideUp("slow");
    $(".accordion-toggle").not($(this)).removeClass("active");
  });

  $(".accordion-pro").find(".accordion-toggle").click(function() {
    setTimeout(function () {
      $('.accordion-product .accordion-block .accordion-section.active .tab a[select-tab="tab1"]').trigger('click');
    }, 200);
  });

  $(".accordion-product .accordion-block .tab a").click(function(){
    $(".accordion-product .accordion-block .tab a").removeClass("active");
    $(this).addClass("active");
    var SelectTab = $( this ).attr('select-tab');
    var ShowTab = '[show-tab="'+ SelectTab +'"]';

    $(".content-tab").hide();
    $(ShowTab).fadeIn('fast');
  });
});

// product page image slider
$(document).ready(function() {
  $('.right-image-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: true,
  });
  
});

// Mega Menu
$(document).ready(function(){

  // $(".mega-menu .header__menu-item").click(function(){
  //   $(this).siblings('.mega-menu__content').find('li[select-menu]:first-child').trigger('click');
  // });
  
  // setTimeout(function () {
  //   $('.custom-mega-menu .menu-block .mega-menu__list li[select-menu]:first-child').trigger('click');
  // }, 200);

  $(".custom-mega-menu .menu-block .mega-menu__list li[select-menu]").click(function(){
    // console.log('clicked');
    $(".custom-mega-menu .menu-block .mega-menu__list li[select-menu]").removeClass("active");
    // $(".custom-mega-menu .menu-block .mega-menu__list li[select-menu]:first-child").addClass("active");
    $(this).addClass("active");
    var SelectMenu = $( this ).attr('select-menu');
    var ShowMenu = '[show-menu="'+ SelectMenu +'"]';

    $(".custom-mega-menu .menu-block .child-menu").hide();
    $(".megamenu-button").hide();
    $(ShowMenu).fadeIn('fast');
  });
});


// Mega Menu Icon
$(document).ready(function(){
  $(".custom-icon-mega-menu .icon-mega-menu[icon-mega-menu-show]").hide();
  
  // $("header nav .list-menu header-menu details[icon-mega-menu]").click(function(){
  //   console.log('iconmenuckicked');
  //   // $("header nav .list-menu .header-menu details[icon-mega-menu]").removeClass("active");
  //   // $(this).addClass("active");
  //   var SelectIconMegaMenu = $( this ).attr('icon-mega-menu');
  //   var ShowIconMegaMenu = '[icon-mega-menu-show="'+ SelectIconMegaMenu +'"]';

  //   $(".mega-menu-icon .show-icon-mega-menu[icon-mega-menu-show]").hide();
  //   $(ShowIconMegaMenu).fadeIn('fast');
  // });

  
  $("header nav .list-menu .header__menu-item").click(function(){
    var SelectIconMegaMenu = $(this).parent().attr('icon-mega-menu');
    // console.log(SelectIconMegaMenu);
    var ShowIconMegaMenu = '[icon-mega-menu-show="'+ SelectIconMegaMenu +'"]';

    $(".custom-icon-mega-menu .icon-mega-menu[icon-mega-menu-show]").hide();
    // $(ShowIconMegaMenu).fadeIn('fast');
    // $(ShowIconMegaMenu).toggle();
    // $(ShowIconMegaMenu).show();

      if ($(this).parent().attr('open')) {
        $(ShowIconMegaMenu).hide();
      } else {
        $(ShowIconMegaMenu).show();
      }
  });
});


$(document).ready(function(){
  var announcementBarHeight = $(".announcement-bar-section").height();
  $('#MainContent').css('padding-top', announcementBarHeight + 'px');
});


$(document).ready(function(){
  var productPriceHTML = $('.title-price .product-price').html();
  // console.log(productPriceHTML,'productPriceHTML');
  $('.product-price.append').append(productPriceHTML);
  
  
  // $('fieldset label').click(function(){
  //   $('.product-price.append').empty();
  //   setTimeout(function(){
  //     var PriceHTML = $('.title-price .product-price').html();
  //     // console.log(PriceHTML,'PriceHTML');
  //     $('.product-price.append').append(PriceHTML);
  //   },1000)
  // });

  document.addEventListener("variant:price:change", (event) => {
    $('.product-price.append').html(event.detail.innerHTML);
  });
  
});

document.addEventListener("variant:change", (event) => {
  let sku_code = event?.detail?.sku;
  if(sku_code){
    $('.sku_code').html(sku_code);
  }
});

// $(document).ready(function(){
//   let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
//   console.log(items);
//   items.forEach(item => {
//       item.addEventListener("mouseover", () => {
//         item.setAttribute("open", true);
//         item.querySelector("ul").addEventListener("mouseleave", () => {
//           item.removeAttribute("open");
//         });
//       item.addEventListener("mouseleave", () => {
//         item.removeAttribute("open");
//       });
//     });
//   });
// });

$(document).ready(function() {
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  
  
  items.forEach(item => {
    // Add event listener for mouseenter on the details element
    item.addEventListener("mouseenter", () => {
      item.setAttribute("open", true); // Open the details element
      
      // Trigger a click event on the first 'li' element with 'select-menu' attribute
      const firstMenuItem = item.querySelector('.mega-menu__content li[select-menu]');
      if (firstMenuItem) {
        firstMenuItem.click();
      }
    });
    
    // Add event listener for mouseleave on the details element
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open"); // Close the details element
    });
  });
});

// Footer Accordian
$(document).ready(function() {
  if ($(window).width() < 750) {
  $(".Footer__accordion_faq").find(".Footer__accordion_heading").click(function() {
    $(this).next().slideToggle("slow");
      $(this).toggleClass("active");
      $(".Footer__accordion_content").not($(this).next()).slideUp("slow");
      $(".Footer__accordion_heading").not($(this)).removeClass("active");
  });
  }
});

// Alternate collection page script start
function updateCategoryDisplay() {
  $('.category-section .category-block .category').css('display', 'flex');
}

// Initial call to set the display
setTimeout(updateCategoryDisplay, 500);

// Handle window resize
$(window).on('resize', function() {
  updateCategoryDisplay();
});

$(document).ready(function () {

setTimeout(function(){
  var announcementBarHeight = $(".announcement-bar-section").innerHeight();

  var headerMenuHeight = $(".header-wrapper").innerHeight();

  var totalHeight = announcementBarHeight + headerMenuHeight;

  var discountSectionHeight = $(".template-collection .discount-section").innerHeight();
  var categoryImageHeight = $(".template-collection .category-section .category img").innerHeight();

  var categoryButtonHeight = $(".template-collection .category-section .category p").innerHeight();

  
  var totalHeight2 = announcementBarHeight + discountSectionHeight + categoryImageHeight - categoryButtonHeight;

  var alltotalHeight = totalHeight + categoryImageHeight;

  // console.log(totalHeight2,'totalHeight2');

  var announcementHeaderHeight = announcementBarHeight + headerMenuHeight;
  
  var categoryFixedHeight = announcementHeaderHeight - categoryImageHeight;
  
  var scrollFixedHeight = totalHeight + categoryButtonHeight;


  // Function to handle the fixed block logic
    function handleFixedBlock() {
        const scrollTop = $(window).scrollTop();
    
        if (scrollTop >= totalHeight2) {
            $('.template-collection .category-section').addClass('fixed-block');
            $('.template-collection .category-section.fixed-block').css('top', categoryFixedHeight + "px");
        } else {
            $('.template-collection .category-section').removeClass('fixed-block');
            $('.template-collection .category-section').css('top', "0");
        }
    }
    
    // Run the function on page load
    $(document).ready(function () {
        handleFixedBlock(); // Initial check when the page loads
    });
    
    // Also run the function on scroll
    $(window).scroll(function () {
        handleFixedBlock();
    });

    $(document).ready(function() {
      $(document).on('click', '.template-collection a[href^="#"]', function (event) {
        event.preventDefault();
      
        $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top - scrollFixedHeight
        }, 1000);
      });
    });
},1000)  
});
// Alternate collection page script end


  function getUserId() {
    return window.customerId || undefined;
  }

  function getUserType() {
    return window.isLoggedIn ? 'logged_in' : 'guest';
  }

  function getPageType() {
    const url = window.location.pathname;
    if (url === "/" || url === "/home" || url === "") return "home";
    if (url.includes("/collections/")) return "collection_page";
    if (url.includes("/products/")) return "product_page";
    if (url.includes("/cart")) return "cart_page";
    if (url.includes("/faqs")) return "faq_page";
    if (url.includes("/jobs")) return "Careers";
    if (url.includes("/warranty")) return "Warranty";
    if (url.includes("/care-tips")) return "care-tips";
    if (url.includes("/return_prime")) return "Returns & Exchanges";
    if (url.includes("/blogs")) return "blogs";
    if (url.includes("/about")) return "about";
    if (url.includes("/our-social-impact-new")) return "our-social-impact-new";
    if (url.includes("/our-path-forward")) return "our-path-forward";
    if (url.includes("/crafting-excellence")) return "crafting-excellence";
    if (url.includes("/crafting-materials")) return "crafting-materials";
    if (url.includes("/tww-basf")) return "tww-basf";
    if (url.includes("/checkouts/") || url.includes("/thank_you")) return "order_confirmation_page";
    return "other";
  }

  document.addEventListener("DOMContentLoaded", function () {
    const intervalId = setInterval(() => {
      const whatsappButton = document.querySelector("#whatsapp-trigger-button"); // <-- Updated to match your HTML
      
      if (whatsappButton) {
        

        // Attach listener only once
        whatsappButton.addEventListener("click", function () {
        let ctaText = whatsappButton.querySelector("span")?.innerText || "Close Chat";
        if (event.currentTarget.classList.contains('is-active')) {
          ctaText = "Start Chat";
        }



          const userId = getUserId();
          const userType = getUserType();
          const pageType = getPageType();

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'whatsapp_interaction',
            'page_type': pageType,
            'platform': getPlatform(),
            'cta_text': ctaText,
            'user_id_event': userId,
            'user_type_event': userType
          });

          console.log("🟢 dataLayer event pushed:", {
            'event': 'whatsapp_interaction',
            'page_type': pageType,
            'cta_text': ctaText,
            'platform': getPlatform(),
            'user_id_event': userId,
            'user_type_event': userType
          });
        });

        clearInterval(intervalId); // stop checking once button found
      }
    }, 1000); // check every 1 second

    // Safety timeout to stop polling after 15 seconds
    setTimeout(() => clearInterval(intervalId), 15000);
  });




// Track popup interaction
// function setupPopupListeners() {
//   const popupElements = document.querySelectorAll('[data-testid="animated-teaser"]');
//   const pageType = getPageType();
//   popupElements.forEach(popup => {
//     if (popup.hasAttribute('data-popup-listener')) return; // ✅ prevent duplicate listener

//     popup.setAttribute('data-popup-listener', 'true');
//     popup.addEventListener('click', () => {
//       const title = popup.getAttribute('data-pop-up-title') ||
//                     popup.querySelector('.popup-title')?.innerText.trim() ||
//                     popup.innerText.trim() || '';
//       window.dataLayer = window.dataLayer || [];
//       window.dataLayer.push({
//         event: 'pop_up_cta_click',
//         pop_up_title: title,
//         page_type: pageType,
//         user_id_event: getUserId(),
//         user_type: getUserType(),
//         platform: getPlatform()
//       });
//       console.log('pop_up_cta_click event pushed:', {
//         pop_up_title: title,
//         user_id_event: getUserId(),
//         user_type: getUserType(),
//         platform: getPlatform()
//       });
//     });
//   });
// }
// let popupListenerInterval = setInterval(setupPopupListeners, 500);
// setTimeout(() => clearInterval(popupListenerInterval), 10000);

// Track popup form submission buttons
// function setupPopupButtonListeners() {
//   const popupButtons = document.querySelectorAll('[data-testid="klaviyo-form-QWi3XF"] button');
//   popupButtons.forEach(button => {
//     if (button.hasAttribute('data-button-listener')) return; // ✅ prevent duplicate listener

//     button.setAttribute('data-button-listener', 'true');
//     button.addEventListener('click', () => {
//       const form = button.closest('form');
//       if (!form) return;

//       const popup = form;
//       const title = popup?.querySelector('h1').innerText ||
//                     popup?.querySelector('h1')?.innerText.trim() ||
//                     popup?.innerText.trim() || '';
//                     console.log(title);
                    
//       window.dataLayer = window.dataLayer || [];
//       window.dataLayer.push({
//         event: 'pop_up_form_submitted',
//         pop_up_title: title,
//         user_id_event: getUserId(),
//         user_type: getUserType(),
//         platform: getPlatform()
//       });

//       console.log('pop_up_form_submitted event pushed:', {
//         pop_up_title: title,
//         user_id_event: getUserId(),
//         user_type: getUserType(),
//         platform: getPlatform()
//       });
//     });
//   });
// }
// let popupButtonInterval = setInterval(setupPopupButtonListeners, 500);
// setTimeout(() => clearInterval(popupButtonInterval), 12000);


document.addEventListener('DOMContentLoaded', function () {
  const colorInputs = document.querySelectorAll('.swatches-container input[type="radio"][name="Color"]');
  
  if (!colorInputs.length) return;

  colorInputs.forEach(input => {
    input.addEventListener('change', function () {
      const colorName = this.value || this.getAttribute('value');
      const productName = document.querySelector('.product__info-container h1')?.innerText?.trim() || 'Unknown Product';
      const pageType = 'product_page';

      
      dataLayer.push({
        event: 'color_interaction',
        page_type: getPageType(),
        platform: getPlatform(),
        product_name: productName,
        color_name: colorName,
        user_id_event: getUserId(),
        user_type_event: getUserType()
      });
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  // Ensure dataLayer exists
  window.dataLayer = window.dataLayer || [];


  // --- SIZE OPTION TRACKING ---
  // const sizeInputs = document.querySelectorAll('.dropdown-options input[type="radio"][name="Size"]');

  // if (sizeInputs.length) {
  //   sizeInputs.forEach(input => {
  //     input.addEventListener('change', function (e) {
  //       const sizeName = this.value?.trim() || this.getAttribute('value')?.trim();
  //       const productName =
  //         document.querySelector('.product__info-container h1, h1.product__title')?.innerText?.trim() ||
  //         'Unknown Product';

  //       // Prevent duplicate firing (for safety)
  //       if (this.dataset.tracked === 'true') return;
  //       this.dataset.tracked = 'true';
  //       setTimeout(() => (this.dataset.tracked = 'false'), 200); // reset tracking state

  //       window.dataLayer.push({
  //         event: 'size_interaction',
  //         page_type: getPageType(),
  //         platform: getPlatform(),
  //         product_name: productName,
  //         size_name: sizeName,
  //         user_id_event: getUserId(),
  //         user_type_event: getUserType()
  //       });

  //       console.log('✅ dataLayer event pushed:', {
  //         event: 'size_interaction',
  //         page_type: getPageType(),
  //         platform: getPlatform(),
  //         product_name: productName,
  //         size_name: sizeName,
  //         user_id_event: getUserId(),
  //         user_type_event: getUserType()
  //       });
  //     });
  //   });
  // }
});

document.addEventListener('DOMContentLoaded', function () {
  // Ensure dataLayer exists
  window.dataLayer = window.dataLayer || [];

  // --- FIRMNESS OPTION TRACKING ---
  const firmnessInputs = document.querySelectorAll('.product-swatch-options.firmness input[type="radio"][name="Pillow Firmness"]');

  if (firmnessInputs.length) {
    firmnessInputs.forEach(input => {
      input.addEventListener('change', function () {
        const firmnessSize = this.value?.trim() || this.getAttribute('value')?.trim();
        const productName =
          document.querySelector('.product__info-container h1, h1.product__title')?.innerText?.trim() ||
          'Unknown Product';

        // Prevent double-firing safeguard
        if (this.dataset.tracked === 'true') return;
        this.dataset.tracked = 'true';
        setTimeout(() => (this.dataset.tracked = 'false'), 200);

        window.dataLayer.push({
          event: 'firmness_selection',
          page_type: getPageType(),
          platform: getPlatform(),
          product_name: productName,
          firmness_size: firmnessSize,
          user_id_event: getUserId(),
          user_type_event: getUserType()
        });

        console.log('✅ dataLayer event pushed:', {
          event: 'firmness_selection',
          page_type: getPageType(),
          platform: getPlatform(),
          product_name: productName,
          firmness_size: firmnessSize,
          user_id_event: getUserId(),
          user_type_event: getUserType()
        });
      });
    });
  }
});


document.addEventListener('DOMContentLoaded', function () {
  // Ensure dataLayer exists
  window.dataLayer = window.dataLayer || [];


  // --- HEIGHT OPTION TRACKING ---
  const heightInputs = document.querySelectorAll(
    '.product-form__input.custom-option input[type="radio"][name="Pillow Height"]'
  );

  if (heightInputs.length) {
    heightInputs.forEach(input => {
      input.addEventListener('change', function () {
        const heightValue = this.value?.trim() || this.getAttribute('value')?.trim();
        const productName =
          document.querySelector('.product__info-container h1, h1.product__title')?.innerText?.trim() ||
          'Unknown Product';

        // Prevent double firing
        if (this.dataset.tracked === 'true') return;
        this.dataset.tracked = 'true';
        setTimeout(() => (this.dataset.tracked = 'false'), 200);

        window.dataLayer.push({
          event: 'height_selection',
          page_type: getPageType(),
          product_name: productName,
          platform: getPlatform(),
          height_selection: heightValue,
          user_id_event: getUserId(),
          user_type_event: getUserType(),
        });

        console.log('✅ dataLayer event pushed:', {
          event: 'height_selection',
          page_type: getPageType(),
          platform: getPlatform(),
          product_name: productName,
          height_selection: heightValue,
          user_id_event: getUserId(),
          user_type_event: getUserType(),
        });
      });
    });
  }
});


document.addEventListener('DOMContentLoaded', function () {
  // Ensure dataLayer exists
  window.dataLayer = window.dataLayer || [];


  // --- ACCORDION TRACKING ---
  const accordions = document.querySelectorAll('.accordion-section');

  accordions.forEach(section => {
    const toggle = section.querySelector('.accordion-toggle');
    const content = section.querySelector('.accordion-content');

    if (!toggle || !content) return;

    toggle.addEventListener('click', function () {
      // Determine state
      const isExpanded = !content.classList.contains('active') && content.style.display !== 'block';
      const selectionType = isExpanded ? 'expand' : 'collapse';

      // Determine section name (like Orders, Shipping, etc.)
      const sectionName = toggle.innerText.trim() || 'Unknown Section';
      const ctaText = sectionName; // same as section title

      // Toggle the accordion (if not already handled by theme JS)
      content.classList.toggle('active');

      // Push event
      window.dataLayer.push({
        event: 'dropdown_interaction',
        page_type: getPageType(),
        platform: getPlatform(),
        section_name: sectionName,
        selection_type: selectionType,
        cta_text: ctaText,
        user_id_event: getUserId(),
        user_type_event: getUserType(),
      });

      console.log('✅ dataLayer event pushed:', {
        event: 'dropdown_interaction',
        page_type: getPageType(),
        section_name: sectionName,
        selection_type: selectionType,
        cta_text: ctaText,
        user_id_event: getUserId(),
        user_type_event: getUserType(),
      });
    });
  });
});

// Run an interval to detect when the discount input appears
  const couponInterval = setInterval(() => {
    const couponInput = document.querySelector('input[name="discount"]');
    const applyButton = document.querySelector('.discounts-wrapper button, .discounts-wrapper [type="submit"]');

    if (couponInput && applyButton) {
      clearInterval(couponInterval);

      // Attach listener when user applies a coupon
      applyButton.addEventListener('click', () => {
        const couponCode = couponInput.value.trim();
        if (couponCode !== '') {
          dataLayer.push({
            event: 'coupon_code',
            page_type: '{{dynamic}}', // e.g., product_page, cart_page, etc.
            cta_text: 'apply',
            user_id_event: '{{Shopify Customer id}}',
            user_type_event: '{{dynamic}}' // logged_in or guest
          });
        }
      });
    }
  }, 1000); 

document.addEventListener('DOMContentLoaded', function () {
  window.dataLayer = window.dataLayer || [];


  // --- Scroll tracking ---
  const scrollThresholds = [25, 50, 75, 100];
  const triggered = new Set();

  function trackScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const percentScrolled = Math.round((scrollTop / docHeight) * 100);

    scrollThresholds.forEach(threshold => {
      if (percentScrolled >= threshold && !triggered.has(threshold)) {
        triggered.add(threshold);

        window.dataLayer.push({
          event: 'scroll',
          page_type: getPageType(),
          percent_scrolled: threshold,
          user_id_event: getUserId(),
          user_type_event: getUserType(),
        });

        console.log(`✅ Scroll event fired: ${threshold}%`, {
          event: 'scroll',
          page_type: getPageType(),
          percent_scrolled: threshold,
          user_id_event: getUserId(),
          user_type_event: getUserType(),
        });
      }
    });
  }

  window.addEventListener('scroll', trackScroll);
});

// document.addEventListener('DOMContentLoaded', function () {
//   window.dataLayer = window.dataLayer || [];


//   // --- Select all CTA elements ---
//   const ctaElements = document.querySelectorAll(
//     '.content-block a, .reviews-inner a, .product-block a'
//   );

//   ctaElements.forEach((cta) => {
//     cta.addEventListener('click', function () {
//       const ctaText =
//         (this.innerText || this.value || this.getAttribute('aria-label') || '').trim();

//       // Skip blank CTA text
//       if (!ctaText) return;

//       const linkPath =
//         this.getAttribute('href') ||
//         this.dataset.href ||
//         (this.closest('a')?.getAttribute('href') || 'no_link');

//       const sectionName =
//         this.closest('.content-block')?.querySelector('.main-title').innerText ||
//         this.closest('.product-block')?.querySelector('.title').innerText ||
//         this.closest('.reviews-inner')?.querySelector('h2').innerText ||
//         this.closest('.image-with-text__text-item')?.querySelector('.image-with-text__heading').innerText ||
//         'unknown_section';

//       // --- Push event to dataLayer ---
//       window.dataLayer.push({
//         event: 'cta_click',
//         page_type: getPageType(),
//         section_name: sectionName,
//         cta_text: ctaText,
//         platform: getPlatform(),
//         link_path: linkPath,
//         user_id_event: getUserId(),
//         user_type_event: getUserType(),
//       });

//       console.log('✅ CTA Click Event Fired:', {
//         event: 'cta_click',
//         page_type: getPageType(),
//         section_name: sectionName,
//         platform: getPlatform(),
//         cta_text: ctaText,
//         link_path: linkPath,
//         user_id_event: getUserId(),
//         user_type_event: getUserType(),
//       });
//     });
//   });
// });



document.addEventListener('DOMContentLoaded', function () {
  window.dataLayer = window.dataLayer || [];

  // ✅ Single delegated event listener (robust against re-renders)
  document.addEventListener('click', function (event) {
    const emiButton = event.target.closest('#sm-widget-btn');
    const platform = getPlatform();
    if (!emiButton) return; // Clicked somewhere else

    const ctaText =
      (emiButton.innerText || emiButton.value || emiButton.getAttribute('aria-label') || '').trim();

    if (!ctaText) return;

    window.dataLayer.push({
      event: 'emi_interaction',
      page_type: getPageType(),
      cta_text:"The White Willow Pay Later",
      user_id_event: getUserId(),
      user_type_event: getUserType(),
      platform: getPlatform(),
    });

    console.log('✅ EMI Interaction Fired:', {
      event: 'emi_interaction',
      platform: getPlatform(),
      page_type: getPageType(),
      cta_text: ctaText,
      user_id_event: getUserId(),
      user_type_event: getUserType(),

    });
  });
});



  


  // Function to attach arrow click tracking
  function setupArrowClickTracking() {
    const arrowButtons = document.querySelectorAll(
      '.slider-button--prev, .slider-button--next, .flickity-prev-next-button.previous, .flickity-prev-next-button.next, .slick-prev, .slick-next'
    );

    arrowButtons.forEach(button => {
      if (button.dataset.trackingBound === "true") return; // prevent double binding
      button.dataset.trackingBound = "true";

      button.addEventListener('click', function () {
        let selectionType = "NA";

        if (
          button.classList.contains('slider-button--prev') ||
          button.classList.contains('previous') ||
          button.classList.contains('slick-prev')
        ) {
          selectionType = "left_arrow";
        } else if (
          button.classList.contains('slider-button--next') ||
          button.classList.contains('next') ||
          button.classList.contains('slick-next')
        ) {
          selectionType = "right_arrow";
        }

        // ✅ Find section name from closest .shopify-section > first div class
        const shopifySection = button.closest('.shopify-section');
        let sectionName = shopifySection.querySelector('.super-title')?.innerText || shopifySection.querySelector('.title')?.innerText || shopifySection.querySelector('.reviews-inner h2')?.innerText ;
        if (event.currentTarget.closest('.announcement-bar-slider')) {
          sectionName='hellobar_home'
        }
      if (event.currentTarget.closest('.trust-icon-with-text')) {
          sectionName='usp_home'
        }
        const data = {
          event: 'arrow_click',
          page_type: getPageType(),
          section_name: sectionName,
          selection_type: selectionType,
          user_id_event: getUserId(),
          user_type_event: getUserType()
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);

        console.log("✅ GA4 arrow_click event fired:", data);
      });
    });
  }

  // Run initially and re-check every 2 seconds for dynamically loaded carousels
  setupArrowClickTracking();
  setInterval(setupArrowClickTracking, 2000);


// Track Blog Card and CTA Clicks
function setupBlogClickTracking() {
  const blogLinks = document.querySelectorAll(
    '.multicolumn-card__info a.link.animate-arrow, .article-template__content a, .article-template__back a'
  );
  
  if (!blogLinks.length) return;

  blogLinks.forEach(link => {
    if (link.dataset.trackingBound) return; // prevent duplicate listeners
    link.dataset.trackingBound = true;

    link.addEventListener('click', () => {
      const blogCard = link.closest('.multicolumn-card');
      const blogNameEl = blogCard?.querySelector('img');
      let blogName = blogNameEl?.alt || document.title || 'Featured In';
      const ctaText = link.textContent.trim();
      const pageType = getPageType();
      const userId = Shopify?.customer?.id || null;
      const userType = Shopify?.customer ? 'logged_in' : 'guest';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'blog_click',
        page_type: getPageType(),
        blog_name: blogName,
        cta_text: ctaText,
        link_path: link.href,
        user_id_event: getUserId(),
        user_type_event: getUserType()
      });

      console.log("✅ GA4 blog_click fired:", {
        page_type: getPageType(),
        blog_name: blogName,
        cta_text: ctaText,
        link_path: link.href,
        user_id_event: getUserId(),
        user_type_event: getUserType()
      });
    });
  });
}

// Run once on page load
document.addEventListener('DOMContentLoaded', setupBlogClickTracking);


// document.addEventListener("DOMContentLoaded", function () {
//   const CHECK_INTERVAL_MS = 800;
//   const MAX_WAIT_MS = 20000; // safety stop (optional)
//   let elapsed = 0;

//   const intervalId = setInterval(() => {
//     elapsed += CHECK_INTERVAL_MS;
//     const warrantyForm = document.querySelector('[data-testid="klaviyo-form-Y2uqWX"]');

//     if (!warrantyForm) {
//       if (elapsed >= MAX_WAIT_MS) {
//         // give up after some time to avoid a forever-running interval
//         clearInterval(intervalId);
//         console.warn("warranty form not found within timeout");
//       }
//       return;
//     }

//     console.log("✅ Warranty form detected:", warrantyForm);
//     clearInterval(intervalId);

//     // Prevent double binding
//     if (warrantyForm.dataset.trackingBound === "true") {
//       console.log("⚠️ Warranty tracking already bound");
//       return;
//     }
//     warrantyForm.dataset.trackingBound = "true";

//     // Helper to push the datalayer event
//     function pushWarrantyEvent(triggerSource) {
//       const firest_name = warrantyForm.querySelector('#first_name_016JB91TTR000000000044T8T6').value;
//       try {
//         window.dataLayer = window.dataLayer || [];
//         window.dataLayer.push({
//           event: "warranty_interaction",
//           page_type: (typeof getPageType === "function") ? getPageType() : "NA",
//           section_name: "warranty",
//           field_name: firest_name || 'NA',
//           field_last_name: warrantyForm.querySelector('#last_name_016JB91TTR000000000044T8T7').value || 'NA',
//           field_addreess1: warrantyForm.querySelector('#address1_016JB91TTR000000000044T8T8').value || 'NA',
//           field_addreess2: warrantyForm.querySelector('#address2_016JB91TTR000000000044T8T9').value || 'NA',
//           field_city: warrantyForm.querySelector('#city_016JB91TTR000000000044T8TA').value || 'NA',
//           field_pincode: warrantyForm.querySelector('#zip_016JB91TTR000000000044T8TB').value || 'NA',
//           field_phonenumber: warrantyForm.querySelector('#phone_number_016JB91TTR000000000044T8TC').value || 'NA',
//           field_date: warrantyForm.querySelector('#Shopify_Tags_016JB91TTR000000000044T8TE').value || 'NA',
//           field_order_id: warrantyForm.querySelector('#_016JB91TTR000000000044T8TF').value || 'NA',
//           field_name_product: warrantyForm.querySelector('#title_016JB91TTR000000000044T8TG').value || 'NA',
//           field_purchase: warrantyForm.querySelector('#downshift-0-input').value || 'NA',

//           platform: getPlatform(),
//           cta_text: "Activate your warranty now",
//           user_id_event: (typeof getUserId === "function") ? getUserId() : "NA",
//           user_type_event: (typeof getUserType === "function") ? getUserType() : "NA"
//         });

//         console.log("✅ GA4 warranty_interaction event pushed (trigger:" + triggerSource + ")", {
//           page_type: (typeof getPageType === "function") ? getPageType() : "NA",
//           user_id_event: (typeof getUserId === "function") ? getUserId() : "NA",
//           user_type_event: (typeof getUserType === "function") ? getUserType() : "NA",
//           platform: getPlatform(),
//         });
//       } catch (err) {
//         console.error("Error pushing warranty_interaction:", err);
//       }
//     }

//     // 1) Listen for a native form submit if the form element exists and uses it
//     if (typeof warrantyForm.addEventListener === "function") {
//       warrantyForm.addEventListener("submit", function (evt) {
//         // do NOT preventDefault — we only track
//         pushWarrantyEvent("form_submit");
//       }, { passive: true });
//     }

//     // 2) Delegated click listener inside the form to catch button-like elements
//     warrantyForm.addEventListener("click", function (evt) {
//       const el = evt.target;
//       // find the closest actionable element (button, input[type=submit], or a clickable element)
//       const actionable = el.closest("button, input[type=submit], input[type=button], a, [role='button']");
//       if (!actionable) return;

//       // get text for CTA matching (trim and normalize)
//       const text = (actionable.innerText || actionable.value || "").trim().toLowerCase();

//       // common CTA text to match — adjust array if needed
//       const ctaKeywords = ["activate", "activate your warranty", "activate your warranty now", "submit", "register", "activate warranty", "activate now"];

//       // If the actionable's text/value contains one of CTA keywords, treat as submit
//       const isWarrantyCTA = ctaKeywords.some(k => text.includes(k));

//       // Also treat real submit inputs/buttons as valid
//       const isNativeSubmit = actionable.matches("input[type='submit'], button[type='submit']");

//       if (isWarrantyCTA || isNativeSubmit) {
//         pushWarrantyEvent("click_actionable");
//       }
//     }, { passive: true });

//     // 3) Also watch for inputs that trigger programmatic submission (some widgets call a JS submit function)
//     //    We'll observe DOM changes inside the form and try to detect a success message or a newly added 'submitted' class.
//     const observer = new MutationObserver((mutations) => {
//       for (const m of mutations) {
//         // heuristic: look for a success message node or a class change like "klaviyo-success" or "submitted" (adjust if you know exact)
//         if (
//           m.addedNodes?.length ||
//           (m.target && (m.target.classList && /success|submitted|thank/i.test(m.target.className)))
//         ) {
//           // you can refine the detection logic to look for exact success text when you know it
//           pushWarrantyEvent("mutation_observer");
//           // once we detect success, disconnect observer to avoid duplicates
//           observer.disconnect();
//           break;
//         }
//       }
//     });

//     try {
//       observer.observe(warrantyForm, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
//     } catch (e) {
//       console.warn("Could not start MutationObserver on warranty form:", e);
//     }
//   }, CHECK_INTERVAL_MS);
// });



document.addEventListener("DOMContentLoaded", function () {
  // Wait until the form appears (in case it's dynamically loaded)
  const checkInterval = setInterval(() => {
    const trackForm = document.querySelector('.form__wrapper form');
    if (!trackForm) return;

    clearInterval(checkInterval);
    console.log("✅ Track Order form detected");

    // Prevent double binding
    if (trackForm.dataset.trackingBound === "true") return;
    trackForm.dataset.trackingBound = "true";

    trackForm.addEventListener("submit", function (e) {
      // Ensure both fields are filled
      const orderInput = trackForm.querySelector('input[name="orderName"]');
      const emailInput = trackForm.querySelector('input[name="email"]');
      const orderValue = orderInput?.value.trim() || "";
      const emailValue = emailInput?.value.trim() || "";

      if (!orderValue || !emailValue) {
        console.log("⚠️ Missing input — event not fired");
        return;
      }

      // Determine selection_type dynamically
      const selectionType = emailValue.includes("@")
        ? "email"
        : "phone";

      // Push event to dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "track_order",
        page_type: (typeof getPageType === "function") ? getPageType() : "NA",
        selection_type: selectionType,
        platform: getPlatform(),
        cta_text: "Find your order",
        user_id_event: (typeof getUserId === "function") ? getUserId() : undefined,
        user_type_event: (typeof getUserType === "function") ? getUserType() : "guest"
      });

      console.log("✅ GA4 track_order event fired:", {
        event: "track_order",
        page_type: (typeof getPageType === "function") ? getPageType() : "NA",
        selection_type: selectionType,
        platform: getPlatform(),
        cta_text: "Find your order",
        user_id_event: (typeof getUserId === "function") ? getUserId() : undefined,
        user_type_event: (typeof getUserType === "function") ? getUserType() : "guest"
      });
    });
  }, 500);
});


document.addEventListener("DOMContentLoaded", function () {
  const pagerCheckInterval = setInterval(() => {
    const paginationWrapper = document.querySelector(".pagination-wrapper");
    if (!paginationWrapper) return;

    clearInterval(pagerCheckInterval);
    console.log("✅ Pagination detected:", paginationWrapper);

    // Select all clickable pagination items (numbers or arrows)
    const paginationLinks = paginationWrapper.querySelectorAll("a.pagination__item");

    paginationLinks.forEach((link) => {
      if (link.dataset.trackingBound === "true") return;
      link.dataset.trackingBound = "true";

      link.addEventListener("click", function () {
        const pageNumber =
          link.textContent.trim() ||
          link.getAttribute("aria-label")?.replace("Page ", "") ||
          "NA";

        const sectionName =
          link.closest(".shopify-section")?.querySelector("div")?.classList[0] ||
          "pagination_section";

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "pager_click",
          page_type:"collection_page",
          page_number: pageNumber,
          platform: getPlatform(),
          section_name: 'Collections',
          user_id_event: typeof getUserId === "function" ? getUserId() : undefined,
          user_type_event: typeof getUserType === "function" ? getUserType() : "guest",
        });

        console.log("✅ GA4 pager_click event fired:", {
          event: "pager_click",
          page_type:"collection_page",
          page_number: pageNumber,
          platform: getPlatform(),
          section_name: sectionName,
          user_id_event: typeof getUserId === "function" ? getUserId() : undefined,
          user_type_event: typeof getUserType === "function" ? getUserType() : "guest",
        });
      });
    });
  }, 1000); // Check every second for dynamic PLP rendering
});



function trackPromotionViews() {
  const promotionBanners = document.querySelectorAll('.internal-promo-banner');
  if (!promotionBanners.length) return;

  const observer = new IntersectionObserver((entries) => {
    const visibleItems = [];

    let creativeName;
    let creativeSlot;
    let promotionId;
    let promotionName;

    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const banner = entry.target;

        // Skip already tracked banners
        if (banner.dataset.tracked === "true") return;

        banner.dataset.tracked = "true";

        creativeName = banner.getAttribute('data-creative-name') || 'Unknown Banner';
        // creativeSlot = banner.getAttribute('data-creative-slot') || '1-1';
        creativeSlot = Array.from(banner.closest(`.shopify-section`).parentNode.children).indexOf(banner.closest(`.shopify-section`)) + 1;
        creativeSlot = `${creativeSlot}-1`;

        promotionId = banner.getAttribute('data-promotion-id') || 'NA';
        promotionName = banner.getAttribute('data-promotion-name') || creativeName;

        visibleItems.push({
          creative_name: creativeName,
          creative_slot: creativeSlot,
          promotion_id: promotionId,
          promotion_name: promotionName,
        });
      }
    });

    if (visibleItems.length > 0) {
      const userId = getUserId();
      const userType = getUserType();
      const pageType = getPageType();

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'view_promotion_ce',
        platform: getPlatform(),
        page_type: pageType,
        user_id_event: userId,
        user_status: userType,
        // ecommerce:  visibleItems
        ecommerce :{
          creative_name: creativeName,
          creative_slot: creativeSlot,
          promotion_id: promotionId,
          promotion_name: promotionName,
        }
      });

      console.log('✅ view_promotion event pushed:', {
        pageType,
        userId,
        userType,
        items: visibleItems,
      });
    }
  }, {
    threshold: 0.5, // at least 50% visible
  });

  promotionBanners.forEach((banner) => observer.observe(banner));
}

document.addEventListener('DOMContentLoaded', trackPromotionViews);



function trackSelectPromotion() {
  // Select all promo banners that can be clicked
  const promoBanners = document.querySelectorAll('.internal-promo-banner');

  if (!promoBanners.length) return;

  promoBanners.forEach((banner) => {
    // Prevent multiple event bindings
    if (banner.dataset.clickTracked === "true") return;
    banner.dataset.clickTracked = "true";

    banner.addEventListener('click', () => {
      const creativeName = banner.getAttribute('data-creative-name') || 'Unknown Banner';
      // const creativeSlot = banner.getAttribute('data-creative-slot') || '1-1';
      let creativeSlot = Array.from(banner.closest(`.shopify-section`).parentNode.children).indexOf(banner.closest(`.shopify-section`)) + 1;
      creativeSlot = `${creativeSlot}-1`;
      const promotionId = banner.getAttribute('data-promotion-id') || 'NA';
      const promotionName = banner.getAttribute('data-promotion-name') || creativeName;

      const userId = getUserId();
      const userType = getUserType();
      const pageType = getPageType();

      // Push to dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); // clear previous ecommerce data
      window.dataLayer.push({
        event: 'select_promotion_ce',
        page_type: pageType,
        user_id_event: userId,
        user_status: userType,
        platform: getPlatform(),
        ecommerce: {
              creative_name: creativeName,
              creative_slot: creativeSlot,
              promotion_id: promotionId,
              promotion_name: promotionName,
        },
      });

      console.log('✅ select_promotion event pushed:', {
        event: 'select_promotion_ce',
        page_type: pageType,
        user_id_event: userId,
        platform: getPlatform(),
        user_status: userType,
        ecommerce: {
              creative_name: creativeName,
              creative_slot: creativeSlot,
              promotion_id: promotionId,
              promotion_name: promotionName,
        },
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', trackSelectPromotion);



// ========== Core tracking logic ==========
document.addEventListener('DOMContentLoaded', function () {

  const viewedProducts = new Set(); // Track already clicked products

  // Select all product cards
  const productCards = document.querySelectorAll('.product-card-event');

  
  if (!productCards.length) return;

  productCards.forEach((card) => {
    
    card.addEventListener('click', function (event) {
    
      // Allow only clicks on product card or its children
      if (!event.target.closest('.product-card-event')) return;
      let sort_applied = "NA";
      let activeFilters = [];
      if(document.body.classList.contains("template-collection")){
        sort_applied = document.querySelector(`.facets__form [name="sort_by"]`).selectedOptions[0].text;
        if(window.innerWidth <= 767){
          sort_applied = document.querySelector(`form.mobile-facets [name="sort_by"]`).selectedOptions[0].text;
        }
      
      document.querySelectorAll("facet-filters-form input:checked").forEach((input) => {
          const groupLabel = input.closest("details")?.querySelector("summary span")?.innerText?.trim() || "Unknown Group";
          const labelText = input.value;
          activeFilters.push(`${groupLabel}-${labelText}`);
      });
      const priceMin = document.querySelector("input[name='filter.v.price.gte']")?.value;
      const priceMax = document.querySelector("input[name='filter.v.price.lte']")?.value;
      if (priceMin || priceMax) {
          activeFilters.push(`Price-${priceMin || "NA"}-${priceMax || "NA"}`);
      }

      if(window.innerWidth <= 767){
        activeFilters = [];
        document.querySelectorAll(".mobile-facets__wrapper input:checked").forEach((input) => {
            const groupLabel = input.closest("details")?.querySelector("summary span")?.innerHTML.trim() || "Unknown Group";
            const labelText = input.value;
            activeFilters.push(`${groupLabel}-${labelText}`);
        });
        const priceMin = document.querySelector(".mobile-facets__main input[name='filter.v.price.gte']")?.value;
        const priceMax = document.querySelector(".mobile-facets__main input[name='filter.v.price.lte']")?.value;
        if (priceMin || priceMax) {
            activeFilters.push(`Price-${priceMin || "NA"}-${priceMax || "NA"}`);
        }
      }
      }
      let appliedValue = activeFilters.length > 0 ? activeFilters.join("|") : "NA";

      // Prepare GA4 item object
      const itemData = {
        item_id: card.getAttribute('data-item-id'),
        item_name: card.getAttribute('data-item-name') || 'Unknown Product',
        coupon: 'NA',
        discount: parseFloat(card.getAttribute('data-item-discount')) || 'NA',
        index: parseFloat(card.getAttribute('data-item-index')) || 1,
        item_brand: 'The White Willow',
        item_category: card.getAttribute('data-item-category') || 'Sleep',
        item_category2: card.getAttribute('data-item-category2') || 'Pillow',
        item_category3: card.getAttribute('data-item-category3') || 'NA',
        item_category4: card.getAttribute('data-item-category4') || 'NA',
        item_category5: card.getAttribute('data-item-category5') || 'NA',
        item_list_id: card.getAttribute('data-item-list-id') || 'collection_page',
        item_list_name: card.getAttribute('data-item-list-name') || card.closest('.shopify-section').querySelector('.inline-richtext').innerText,
        item_variant: card.getAttribute('data-item-variant') || 'NA',
        price: parseFloat(card.getAttribute('data-item-price')) || 0,
        quantity: 1,
        item_size: card.getAttribute('data-size') || 'NA',
        item_dimensions: card.getAttribute('data-item-dimensions') || 'NA',
        filter_applied: appliedValue,
        sort_applied: sort_applied,
        shopify_sku_id: card.getAttribute('data-item-sku') || 'NA'
      };

      // User info
      const userId = getUserId();
      const userType = getUserType();
      const pageType = getPageType();

      localStorage.setItem(`item_list_id_${card.getAttribute('data-item-id')}`, card.getAttribute('data-item-list-id') || 'collection_page');
      localStorage.setItem(`item_list_name_${card.getAttribute('data-item-id')}`, card.getAttribute('data-item-list-name') || card.closest('.shopify-section').querySelector('.inline-richtext').innerText);
      // GA4 push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'select_item_ce',
        page_type: pageType,
        user_id_event: userId,
        user_status: userType,
        platform: getPlatform(),
        ecommerce: { items: [itemData] }
      });

      console.log("🟦 GA4 CLICK EVENT SENT:", itemData);

    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const productCards = Array.from(document.querySelectorAll(".product-card-event"));
  if (!productCards.length) return;

  window.dataLayer = window.dataLayer || [];

  const seenCards = new Set(); // to avoid duplicate events per card

  const buildItemFromCard = (card) => {

    let sort_applied = "NA";
    let activeFilters = [];
    if(document.body.classList.contains("template-collection")){
      sort_applied = document.querySelector(`.facets__form [name="sort_by"]`).selectedOptions[0].text;
      if(window.innerWidth <= 767){
        sort_applied = document.querySelector(`form.mobile-facets [name="sort_by"]`).selectedOptions[0].text;
      }
    
    document.querySelectorAll("facet-filters-form input:checked").forEach((input) => {
        const groupLabel = input.closest("details")?.querySelector("summary span")?.innerText?.trim() || "Unknown Group";
        const labelText = input.value;
        activeFilters.push(`${groupLabel}-${labelText}`);
    });
    const priceMin = document.querySelector("input[name='filter.v.price.gte']")?.value;
    const priceMax = document.querySelector("input[name='filter.v.price.lte']")?.value;
    if (priceMin || priceMax) {
        activeFilters.push(`Price-${priceMin || "NA"}-${priceMax || "NA"}`);
    }

    if(window.innerWidth <= 767){
      activeFilters = [];
      document.querySelectorAll(".mobile-facets__wrapper input:checked").forEach((input) => {
          const groupLabel = input.closest("details")?.querySelector("summary span")?.innerHTML.trim() || "Unknown Group";
          const labelText = input.value;
          activeFilters.push(`${groupLabel}-${labelText}`);
      });
      const priceMin = document.querySelector(".mobile-facets__main input[name='filter.v.price.gte']")?.value;
      const priceMax = document.querySelector(".mobile-facets__main input[name='filter.v.price.lte']")?.value;
      if (priceMin || priceMax) {
          activeFilters.push(`Price-${priceMin || "NA"}-${priceMax || "NA"}`);
      }
    }
    }
    let appliedValue = activeFilters.length > 0 ? activeFilters.join("|") : "NA";

    return {
      item_id: card.getAttribute('data-item-id'),
      item_name: card.getAttribute('data-item-name') || 'Unknown Product',
      coupon: 'NA',
      discount: parseFloat(card.getAttribute('data-item-discount')) || 'NA',
      index: parseFloat(card.getAttribute('data-item-index')) || 1,
      item_brand: 'The White Willow',
      item_category: card.getAttribute('data-item-category') || 'Sleep',
      item_category2: card.getAttribute('data-item-category2') || 'Pillow',
      item_category3: card.getAttribute('data-item-category3') || 'NA',
      item_category4: card.getAttribute('data-item-category4') || 'NA',
      item_category5: card.getAttribute('data-item-category5') || 'NA',
      item_list_id: card.getAttribute('data-item-list-id') || 'collection_page',
      item_list_name:
        card.getAttribute('data-item-list-name') ||
        card.closest('.shopify-section')?.querySelector('.inline-richtext')?.innerText ||
        'NA',
      item_variant: card.getAttribute('data-item-variant') || 'NA',
      price: parseFloat(card.getAttribute('data-item-price')) || 0,
      quantity: 1,
      item_size: card.getAttribute('data-size') || 'NA',
      item_dimensions: card.getAttribute('data-item-dimensions') || 'NA',
      filter_applied: appliedValue,
      sort_applied: sort_applied,
      shopify_sku_id: card.getAttribute('data-item-sku') || 'NA'
    };
  };

  // IntersectionObserver to detect when cards enter viewport
  const observer = new IntersectionObserver(
    (entries) => {
      const visibleItems = [];

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const card = entry.target;
          const cardId = card.getAttribute('data-item-id');

          // Avoid firing multiple times for the same card
          if (!seenCards.has(cardId)) {
            seenCards.add(cardId);
            visibleItems.push(buildItemFromCard(card));
          }
        }
      });

      if (visibleItems.length) {
        // Push GA4 event only for newly visible items
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "view_item_list_ce",
          page_type: getPageType(),
          platform: getPlatform(),
          user_id_event: getUserId(),
          user_status: getUserType(),
          ecommerce: { items: visibleItems },
        });

        console.log("GA4 view_item_list_ce fired →", visibleItems);
      }
    },
    {
      threshold: 0.5, // 50% of card in viewport; tweak as needed
    }
  );

  // Observe all cards
  productCards.forEach((card) => observer.observe(card));
});


// function setupRemoveFromCartTracking() {
//   // Check every 500ms for new cart items
//   const interval = setInterval(() => {
//     const removeButtons = document.querySelectorAll('.rebuy-cart__flyout-item-remove');

//     removeButtons.forEach(button => {
//       if (button.dataset.listenerAttached) return; // prevent duplicate listeners
//       button.dataset.listenerAttached = 'true';

//       button.addEventListener('click', () => {
//         const itemEl = button.closest('.rebuy-cart__flyout-item');
//         if (!itemEl) return;

//         const productName = itemEl.querySelector('.rebuy-cart__flyout-item-product-title')?.innerText.trim() || 'unknown';
//         const variant = itemEl.querySelector('.rebuy-cart__flyout-item-variant-title')?.innerText.trim() || 'default';
//         const priceText = itemEl.querySelector('.rebuy-cart__flyout-item-price span')?.innerText.replace('$','').trim() || '0';
//         const quantity = parseInt(itemEl.querySelector('.rebuy-cart__flyout-item-quantity-widget-label')?.innerText.trim()) || 1;

//         window.dataLayer = window.dataLayer || [];
//         dataLayer.push({ ecommerce: null });

//         // dataLayer.push({
//         //   event: 'remove_from_cart_ce',
//         //   page_type: getPageType(),
//         //   platform: getPlatform(),
//         //   user_id_event: getUserId(),
//         //   user_status: getUserType(),
//         //   ecommerce: {
//         //     currency: Shopify.currency.active || 'USD',
//         //     value: (parseFloat(priceText) * quantity).toFixed(2),
//         //     items: [
//         //       {
//         //         item_id: itemEl.dataset.tolstoyProductTile || 'NA', // fallback id
//         //         item_name: productName,
//         //         discount: 'NA',
//         //         item_brand: 'The White Willow',
//         //         item_category: 'NA',
//         //         item_category2: 'NA',
//         //         item_category3: 'NA',
//         //         item_list_id: itemEl.dataset.tolstoyProductTile || 'NA',
//         //         item_list_name: 'Cart',
//         //         item_variant: variant,
//         //         location_id: Shopify.shop,
//         //         price: priceText,
//         //         quantity: quantity
//         //       }
//         //     ]
//         //   }
//         // });

//         // console.log('✅ remove_from_cart pushed:', { productName, variant, price: priceText, quantity });
//       });
//     });
//   }, 500);

//   // Optional: stop after 30s to avoid unnecessary intervals
//   setTimeout(() => clearInterval(interval), 30000);
// }

// document.addEventListener('DOMContentLoaded', setupRemoveFromCartTracking);




/* =======================
   GET CART DATA
======================= */
async function getCartData() {
  try {
    const res = await fetch('/cart.js');
    if (!res.ok) return null;

    const cart = await res.json();

    const items = cart.items.map((item, i) => ({
      item_id: item.sku || item.id,
      item_name: item.product_title || "NA",
      coupon: item.discount_codes?.[0]?.code || "NA",
      discount: JSON.parse(localStorage.getItem(`datalayer_${item.id}`)) != null ? JSON.parse(localStorage.getItem(`datalayer_${item.id}`)).discount : 0,
      index: i + 1,
      item_brand: "The White Willow",
      item_category: item.product_type || "NA",
      item_category2: item.vendor || "NA",
      item_category3: "NA",
      item_category4: JSON.parse(localStorage.getItem(`datalayer_${item.id}`)) != null ? JSON.parse(localStorage.getItem(`datalayer_${item.id}`)).item_category4 : "NA",
      item_category5: item.product_type || "NA",
      item_list_id: localStorage.getItem(`item_list_id_${item.product_id}`) || 'NA',
      item_list_name: localStorage.getItem(`item_list_name_${item.product_id}`) || "NA",
      item_variant: item.variant_title || "NA",
      price: item.final_price / 100,
      quantity: item.quantity,
      item_size: item.variant_options?.join(", ") || "NA",
      item_dimensions: "NA",
      shopify_sku_id: item.sku || "NA",
    }));
    // console.log("items",items);
    if(items.length > 0){
      const freeItems = items.filter(item => item.price === 0);
      freeItems.forEach(element => {
        localStorage.setItem(`datalayer_${element.itemid}`,JSON.stringify(element));
      });
    }

    return {
      total_qty: cart.item_count,
      value: cart.items.reduce((sum, i) => sum + (i.final_price * i.quantity) / 100, 0),
      coupon: cart.cart_level_discount_applications?.[0]?.title || "NA",
      items,
    };

  } catch (err) {
    console.error("Cart.js Error:", err);
    return null;
  }
}


/* =======================
   FIRE EVENT
======================= */
async function fireBeginCheckoutEvent(pushToDT) {
  console.log("🎯 begin_checkout fired");

  const cartData = await getCartData();
  if (!cartData) return;

  dataLayer.push({ ecommerce: null });
  console.log("cartData.items",cartData.items);

  let dtObj = {
    event: "begin_checkout_ce",
    platform: getPlatform(),
    page_type: window.page_type || "cart_page",
    total_qty: cartData.total_qty,
    user_id_event: window.user_id_event || undefined,
    user_status: window.user_status || "guest",
    ecommerce: {
      currency: "INR",
      value: cartData.value,
      coupon: cartData.coupon,
      items: cartData.items
    }
  }

  var formData = new FormData();
  formData.append("attributes[_datalayer]", JSON.stringify(dtObj));
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => console.log(data));

  localStorage.setItem('cart_items_data',JSON.stringify(dtObj));
  if(pushToDT == true) dataLayer.push(dtObj);

  console.log("✅ begin_checkout SENT →", cartData);
}

let allowToTrigger = true;
document.addEventListener('rebuy:smartcart.show', (event) => {
  const smartcart = event.detail.smartcart;
  console.log('rebuy:smartcart.show: smartcart', smartcart);  
  if(allowToTrigger){
    allowToTrigger = false;
    const cart = smartcart.cart;
    const items = cart.items.map((item, i) => ({
      item_id: item.sku || item.id,
      item_name: item.product_title || "NA",
      coupon: item.discount_codes?.[0]?.code || "NA",
      discount: parseFloat(item.product.variants.find(v => String(v.id).includes(item.id)).compare_at_price) > 0 ? parseFloat(item.product.variants.find(v => String(v.id).includes(item.id)).compare_at_price.replace(".00","")) - (item.final_price / 100) : 0,
      index: i + 1,
      item_brand: "The White Willow",
      item_category: item.product_type || "NA",
      item_category2: item.vendor || "NA",
      item_category3: "NA",
      item_category4: JSON.parse(localStorage.getItem(`datalayer_${item.id}`)) != null ? JSON.parse(localStorage.getItem(`datalayer_${item.id}`)).item_category4 : "NA",
      item_category5: item.product_type || "NA",
      item_list_id: localStorage.getItem(`item_list_id_${item.product_id}`) || 'NA',
      item_list_name: localStorage.getItem(`item_list_name_${item.product_id}`) || "NA",
      item_variant: item.variant_title || "NA",
      price: item.final_price / 100,
      quantity: item.quantity,
      item_size: item.variant_options?.join(", ") || "NA",
      item_dimensions: "NA",
      shopify_sku_id: item.sku || "NA"
    }));
    // console.log("items",items);
    if(items.length > 0){
      const freeItems = items.filter(item => item.price === 0);
      freeItems.forEach(element => {
        localStorage.setItem(`datalayer_${element.itemid}`,JSON.stringify(element));
      });
    }

    const cartData = {
      total_qty: cart.item_count,
      value: cart.items.reduce((sum, i) => sum + (i.final_price * i.quantity) / 100, 0),
      coupon: cart.cart_level_discount_applications?.[0]?.title || "NA",
      items,
    };
    if (!cartData) return;

    dataLayer.push({ ecommerce: null });

    console.log("cartData.items",cartData.items);
    let dataItems = [];
    let totalQ = 0;
    cartData.items.forEach(item => {
      totalQ += item.quantity;
      let itemObj = JSON.parse(localStorage.getItem(`datalayer_${item.itemid}`));
      console.log("itemObj",itemObj);
      if(itemObj != null){
        itemObj.quantity = item.quantity;
        dataItems.push(itemObj);
      }
    });
    console.log("dataItems",dataItems);

    let dtObj = {
      event: "view_cart_ce",
      platform: getPlatform(),
      page_type: window.page_type || "cart_page",
      total_qty: totalQ,
      user_id_event: window.user_id_event || undefined,
      user_status: window.user_status || "guest",
      ecommerce: {
        currency: "INR",
        value: cartData.value,
        coupon: cartData.coupon,
        items: cartData.items
      }
    };

    localStorage.setItem('cart_items_data',JSON.stringify(dtObj));
    dataLayer.push(dtObj);
    
    setTimeout( () => {
      allowToTrigger = true;
    },2000);
  }
});

let allowToTriggerR = true;
document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
  const smartcart = event.detail.smartcart;
  const item = event.detail.item;

  console.log("rebuy:smartcart.line-item-removed: smartcart", smartcart, item);
  if(allowToTriggerR){
    allowToTriggerR = false;
    dataLayer.push({ ecommerce: null });
    let dataItems = [];
    let totalQ = smartcart.cart.item_count - item.quantity;
    let itemObj = {
      item_id: item.sku || item.id,
      item_name: item.product_title || "NA",
      coupon: item.discount_codes?.[0]?.code || "NA",
      discount: item.discounted_price/100,
      index: 0,
      item_brand: "The White Willow",
      item_category: item.product_type || "NA",
      item_category2: item.vendor || "NA",
      item_category3: "NA",
      item_category4: JSON.parse(localStorage.getItem(`datalayer_${item.id}`)) != null ? JSON.parse(localStorage.getItem(`datalayer_${item.id}`)).item_category4 : "NA",
      item_category5: item.product_type || "NA",
      item_list_id: "cart_items",
      item_list_name: "Cart Items",
      item_variant: item.variant_title || "NA",
      price: item.final_price / 100,
      quantity: item.quantity,
      item_size: item.variant_options?.join(", ") || "NA",
      item_dimensions: "NA",
      shopify_sku_id: item.sku || "NA"
    };
    dataItems.push(itemObj);
    console.log("dataItems",dataItems);
    dataLayer.push({
      event: "remove_from_cart_ce",
      platform: getPlatform(),
      page_type: window.page_type || "cart_page",
      total_qty: totalQ,
      user_id_event: window.user_id_event || undefined,
      user_status: window.user_status || "guest",
      ecommerce: {
        currency: "INR",
        value: (item.price*item.quantity)/100,
        coupon: "NA",
        items: dataItems
      }
    });
    setTimeout( () => {
      allowToTriggerR = true;
    },2000);
  }

});

document.addEventListener('rebuy:cart.add', (event) => {
    console.log('rebuy:cart.add event', event.detail);
    if(event.detail.item.properties && event.detail.item.properties['_attribution'] == 'Rebuy Cart'){
      dataLayer.push({ ecommerce: null });
      let dataItems = [];
      let item = event.detail.item;
      let totalQ = item.quantity;
      let itemObj = {
        item_id: item.sku || item.id,
        item_name: item.product_title || "NA",
        coupon: item.discount_codes?.[0]?.code || "NA",
        discount: item.discounted_price/100,
        index: 1,
        item_brand: "The White Willow",
        item_category: item.product_type || "NA",
        item_category2: item.vendor || "NA",
        item_category3: "NA",
        item_category4: "NA",
        item_category5: item.product_type || "NA",
        item_list_id: "cart_items",
        item_list_name: "Cart Items",
        item_variant: item.variant_title || "NA",
        price: item.final_price / 100,
        quantity: item.quantity,
        item_size: item.variant_options?.join(", ") || "NA",
        item_dimensions: "NA",
        shopify_sku_id: item.sku || "NA",
      };
      dataItems.push(itemObj);
      console.log("dataItems",dataItems);
      dataLayer.push({
        event: "add_to_cart_ce",
        platform: getPlatform(),
        page_type: window.page_type || "cart_page",
        total_qty: totalQ,
        user_id_event: window.user_id_event || undefined,
        user_status: window.user_status || "guest",
        ecommerce: {
          currency: "INR",
          value: (item.price*item.quantity)/100,
          coupon: "NA",
          items: dataItems
        }
      });
    }
});

document.addEventListener("rebuy:smartcart.line-item-increase", (event) => {
  const smartcart = event.detail.smartcart;
  const item = event.detail.item;
  console.log("rebuy:smartcart.line-item-increase: smartcart", smartcart, item);
  dataLayer.push({ ecommerce: null });
  let dataItems = [];
  let totalQ = smartcart.cart.item_count + 1;
  let itemObj = {
    item_id: item.sku || item.id,
    item_name: item.product_title || "NA",
    coupon: item.discount_codes?.[0]?.code || "NA",
    discount: item.discounted_price/100,
    index: 0,
    item_brand: "The White Willow",
    item_category: item.product_type || "NA",
    item_category2: item.vendor || "NA",
    item_category3: "NA",
    item_category4: JSON.parse(localStorage.getItem(`datalayer_${item.id}`)) != null ? JSON.parse(localStorage.getItem(`datalayer_${item.id}`)).item_category4 : "NA",
    item_category5: item.product_type || "NA",
    item_list_id: "cart_items",
    item_list_name: "Cart Items",
    item_variant: item.variant_title || "NA",
    price: item.final_price / 100,
    quantity: 1,
    item_size: item.variant_options?.join(", ") || "NA",
    item_dimensions: "NA",
    shopify_sku_id: item.sku || "NA"
  };
  dataItems.push(itemObj);
  console.log("dataItems",dataItems);
  dataLayer.push({
    event: "add_to_cart_ce",
    platform: getPlatform(),
    page_type: window.page_type || "cart_page",
    total_qty: totalQ,
    user_id_event: window.user_id_event || undefined,
    user_status: window.user_status || "guest",
    ecommerce: {
      currency: "INR",
      value: (item.price*item.quantity)/100,
      coupon: "NA",
      items: dataItems
    }
  });
  fireBeginCheckoutEvent(false);
});

document.addEventListener("rebuy:smartcart.line-item-decrease", (event) => {
  const smartcart = event.detail.smartcart;
  const item = event.detail.item;
  console.log("rebuy:smartcart.line-item-decrease smartcart", smartcart, item);
  dataLayer.push({ ecommerce: null });
  let dataItems = [];
  let totalQ = smartcart.cart.item_count - 1;
  let itemObj = {
    item_id: item.sku || item.id,
    item_name: item.product_title || "NA",
    coupon: item.discount_codes?.[0]?.code || "NA",
    discount: item.discounted_price/100,
    index: 0,
    item_brand: "The White Willow",
    item_category: item.product_type || "NA",
    item_category2: item.vendor || "NA",
    item_category3: "NA",
    item_category4: JSON.parse(localStorage.getItem(`datalayer_${item.id}`)) != null ? JSON.parse(localStorage.getItem(`datalayer_${item.id}`)).item_category4 : "NA",
    item_category5: item.product_type || "NA",
    item_list_id: "cart_items",
    item_list_name: "Cart Items",
    item_variant: item.variant_title || "NA",
    price: item.final_price / 100,
    quantity: 1,
    item_size: item.variant_options?.join(", ") || "NA",
    item_dimensions: "NA",
    shopify_sku_id: item.sku || "NA"
  };
  dataItems.push(itemObj);
  console.log("dataItems",dataItems);
  dataLayer.push({
    event: "remove_from_cart_ce",
    platform: getPlatform(),
    page_type: window.page_type || "cart_page",
    total_qty: totalQ,
    user_id_event: window.user_id_event || undefined,
    user_status: window.user_status || "guest",
    ecommerce: {
      currency: "INR",
      value: (item.price*item.quantity)/100,
      coupon: "NA",
      items: dataItems
    }
  });
  fireBeginCheckoutEvent(false);
});


/* ==========================================================
   LISTEN GLOBALLY → CAPTURE PHASE (This FIXES GoKwik blocks)
========================================================== */
document.addEventListener(
  "click",
  function (event) {
    const btn = event.target.closest(".gokwik-checkout button, #gokwik-checkout-btn, .gk-checkout-btn");

    if (btn) {
      console.log("🔥 GoKwik Button Click Detected");
      fireBeginCheckoutEvent(true);
    }
  },
  true // <-- IMPORTANT: capture phase before GoKwik overrides it
);


/* ==========================================================
   INTERVAL → FOR SAFETY IF BUTTON IS ADDED LATE
========================================================== */
const intervalId = setInterval(() => {
  const btn = document.querySelector(".gokwik-checkout button");

  if (btn) {
    console.log("⏳ Button found inside interval");
    clearInterval(intervalId);
  }
}, 500);
